import Section from "../../modules/section/Section";
import Picture from "../../atoms/picture/Picture";
import lawfirm from "../../../../src/assets/images/4.jpg";
import Balls from "../../modules/balls/Balls";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();
  const aboutUsSections = [
    {
      cards: [
        {
          title: t("strategicLegalPartner"),
          description: t("aboutUsDescription1"),
        },
        {
          title: t("strategicCounsel"),
          description: t("aboutUsDescription2"),
        },
      ],
    },
    {
      cards: [
        {
          title: t("expertise"),
          description: t("aboutUsDescription3"),
        },
      ],
    },
    {
      cards: [
        {
          title: t("clientPortfolio"),
          description: t("aboutUsDescription4"),
        },
      ],
    },
  ];

  return (
    <>
      <Section marginBottom>
        <div className={"relative"}>
          <Picture
            className={"atm-picture--group bw-image"}
            srcDesktop={lawfirm}
            srcMobile={lawfirm}
            alt={"Man and girl in busy city street"}
          />
          <Balls left mobileHidden />
        </div>
      </Section>
      <Section container contentGrid>
        {aboutUsSections.map((section) => {
          return (
            <div className={"content-grid-section"}>
              {section.cards.map((card) => {
                return (
                  <div className={"content-grid-card"}>
                    <h3>{card.title}</h3>
                    <div>{card.description}</div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </Section>
    </>
  );
};

export default AboutUs;
